import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ConfigProvider } from "vant";
import "vant/es/toast/style";
import "vant/es/notify/style";
import "vant/es/dialog/style";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function (__props) {
        var themeVars = {
            submitBarPriceColor: "#3DABA4",
        };
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_unref(ConfigProvider), {
                "theme-vars": themeVars,
                style: { height: '100%' }
            }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_router_view)
                ]; }),
                _: 1
            }));
        };
    }
});
